import React from 'react';
import PageFrame from './PageFrame';
import AdsTabs, { AdsTab } from './AdsTabs';
import DashboardFamilyHeader from '../dashboard/DashboardFamilyHeader';
import { ShellChromeProvider } from './ShellChromeContext';

/**
 * SettingsTemplate — wide page frame + section anchor nav (scroll, not tabs).
 */
const SettingsTemplate = ({
  children,
  className = '',
  dir,
  title,
  description,
  navItems = [],
  activeNavId,
  onNavClick,
  dashboardReturn = false,
}) => {
  const settingsNav =
    navItems.length > 0 ? (
      <AdsTabs
        variant="pill"
        className="settings-page__top-nav"
        role="navigation"
        aria-label={title || 'Settings'}
      >
        {navItems.map((item) => {
          const SectionIcon = item.icon;
          const active = activeNavId === item.id;
          return (
            <AdsTab
              key={item.id}
              icon={SectionIcon}
              active={active}
              role="button"
              aria-selected={undefined}
              aria-current={active ? 'true' : undefined}
              onClick={() => onNavClick?.(item.id)}
            >
              {item.label}
            </AdsTab>
          );
        })}
      </AdsTabs>
    ) : null;

  return (
  <ShellChromeProvider titleOwned={dashboardReturn}>
  <PageFrame
    className={[
      'ads-settings-template',
      'settings-page',
      'ads-screen-settings',
      'ads-screen-settings--topnav',
      dashboardReturn ? 'dashboard-family-page' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    dir={dir}
    wide
  >
    <div
      className="settings-page__main settings-page__main--full ads-screen-settings__content"
      role="region"
      aria-label={title || 'Settings'}
    >
      {dashboardReturn ? (
        <DashboardFamilyHeader
          title={title}
          subtitle={description}
          center={settingsNav}
        />
      ) : (
        <>
          <header className="ads-settings-template__header settings-page__header">
            {title ? <h1 className="settings-page__title ads-type-page-title">{title}</h1> : null}
            {description ? <p className="settings-page__desc ads-type-caption">{description}</p> : null}
          </header>
          {settingsNav ? (
            <div className="ads-screen-settings__nav settings-page__nav-bar">
              {settingsNav}
            </div>
          ) : null}
        </>
      )}
      <div className="ads-settings-template__grid settings-layout-grid">{children}</div>
    </div>
  </PageFrame>
  </ShellChromeProvider>
  );
};

export default SettingsTemplate;
